import Loader from "@/javascript/components/loader"
import selectize from "@/javascript/components/selects"

const applicationsReadMoreOnNotesOverflow = (content) => {
  content.querySelectorAll('.job-applications .js-application-note').forEach((elem) => {
    if(elem.classList.contains('open')) {
      return
    }

    const contentElem = elem.querySelector('.js-content')
    const readMoreElem = elem.querySelector('.js-read-more')

    if(!contentElem || !readMoreElem) {
      return
    }

    if(contentElem.offsetWidth < contentElem.scrollWidth) {
      readMoreElem.classList.remove('hidden')
    } else {
      readMoreElem.classList.add('hidden')
    }
  })
}

window.addEventListener('optimizedResize', () => {
  applicationsReadMoreOnNotesOverflow(document)
  readMoreTogglers(document);
})

Loader.visual((content, resolve) => {
  readMoreTogglers(content);
  resolve();
})

Loader.functional((content, resolve) => {
  bindMyJobFilters(content)
  bindOpenJobsFilters(content)
  bindPositionType(content)
  bindTopMatchesBtnCount(content)
  applicationsReadMoreOnNotesOverflow(content)

  content.querySelectorAll('.actions-dropdown .state-actions a.active').forEach((activeState) => {
    activeState.addEventListener('click', (e) => e.preventDefault())
  })

  resolve()
})

const bindMyJobFilters = (content) => {
  const jobFilterForm = content.querySelector('#job-filter-form')
  if(!jobFilterForm || jobFilterForm.filtersBound) {
    return
  }

  jobFilterForm.filtersBound = true
  jobFilterForm.addEventListener('submit', (e) => {
    e.target.setAttribute('action', window.location.pathname)
  })
}

const bindTopMatchesBtnCount = (content) => {
  const topMatchesTotal = content.querySelector('.top-matches-results-container .top-matches-total')
  if(!topMatchesTotal || !topMatchesTotal.dataset.count) {
    return
  }

  // TODO-LOADER-SCOPE: These elements exist outside the loaded content scope (page-level navigation).
  // Need to investigate Stimulus controller pattern or data attributes to coordinate between content and page-level UI.
  const toggleShowMatches = document.querySelectorAll('a.top-matches-show-hide')
  toggleShowMatches.forEach((btn) => {
    btn.dataset.count = topMatchesTotal.dataset.count
  })

  // TODO-LOADER-SCOPE: Member matches summary is in page header, not in loaded content scope.
  // Consider using custom events or Stimulus to update page-level UI from content changes.
  const MatchesSummary = document.querySelector('.js-member-matches-summary')
  const MatchesSummaryHeading = document.querySelector('.js-member-matches-summary-heading')
  if(!MatchesSummaryHeading && !MatchesSummary) {
    return
  }

  MatchesSummary.dataset.count = topMatchesTotal.dataset.count
  MatchesSummaryHeading.innerHTML = MatchesSummaryHeading.innerHTML.replace('0', topMatchesTotal.dataset.count)

  // TODO: Replace this close button binding by also making the close button a toggle
  // TODO-LOADER-SCOPE: Close button is outside content scope. Same issue as above - needs page-level coordination pattern.
  const closeMatches = document.querySelector('.top-matches-results-container .close-button'
  )
  if(!closeMatches && !closeMatches.clickBound) {
    return
  }

  closeMatches.clickBound = true
  closeMatches.addEventListener('click', () => {
    // TODO-LOADER-SCOPE: Toggle button is outside content scope.
    document.querySelector('a.top-matches-show-hide').click()
  })
}

const bindOpenJobsFilters = (content) => {
  const jobFilterSelect = content.querySelector('select#job_category_ids')
  if(!jobFilterSelect || jobFilterSelect.selectize) {
    return
  }

  selectize(jobFilterSelect,{
    render: {
      option: function(data, escape) {
        let result = '<div class="option">'
        result += '<div class="text">' + escape(data[this.settings.labelField]) + '</div>'
        result += '<div class="count">' + escape(data.count) + '</div>'
        result += '</div>'

        return result
      }
    }
  }).then((selectize) => {
    selectize.on('change', () => {
      content.querySelector('#jobs-filter-form input[type="submit"]').disabled = false
    })
  })
}

const bindPositionType = (content) => {
  const positionType = content.querySelector('.position-type')
  if(!positionType) {
    return
  }

  const radioButtons = positionType.querySelectorAll("input[name='job[position_type]']")

  const onChange = (e) => {
    const value = e.target.value

    positionType.querySelectorAll('input[data-field-for]').forEach((elem) => {
      elem.disabled = elem.dataset.fieldFor !== value
    })
  }

  radioButtons.forEach((elem) => {
    elem.addEventListener('change', onChange)
  })
}

const readMoreTogglers = (content) => {
  jobDescriptionResizer(content)
  adminNotesResizer(content)
}

const jobDescriptionResizer = (content) => {
  const jobDescription = content.querySelector('.job .js-description');
  if (!jobDescription)
    return
  const jobDescriptionInner = jobDescription.querySelector('article.tiny-mce-content');
  if (!jobDescriptionInner)
    return

  if(jobDescriptionInner.offsetHeight < jobDescriptionInner.scrollHeight) {
    jobDescription.classList.add('js-more-to-see')
  } else {
    jobDescription.classList.remove('js-more-to-see')
  }
}

const adminNotesResizer = (content) => {
  const adminNotes = content.querySelector('.job .admin-notes');
  if (!adminNotes)
    return
  const adminNotesInner = adminNotes.querySelector('article.tiny-mce-content');
  if (!adminNotesInner)
    return

  if(adminNotesInner.offsetHeight < adminNotesInner.scrollHeight) {
    adminNotes.classList.add('js-more-to-see')
  } else {
    adminNotes.classList.remove('js-more-to-see')
  }
}
